<template>
  <div >
    <div class="tips" v-if="form_id == 0">重要提醒：所有信息一经提交无法修改，提交前请仔细核对信息！请勿随意申报</div>
    <van-form @submit="onSubmit">
      <van-field
        v-if="form_id != 0"
        v-model="form_id"
        :disabled="disabled"
        label="申请id"
        placeholder=""
      />
      <van-field name="type" v-model="form.type" label="类型" :disabled="disabled" :rules="[{ required: true, message: '请填选择' }]">
        <template #input>
          <van-radio-group :disabled="disabled" v-model="form.type" direction="horizontal">
            <van-radio name="1">个人</van-radio>
            <van-radio name="2">企业</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        v-model="form.name"
        :disabled="disabled"
        name="name"
        label="姓名（企业）"
        placeholder="需和银行账户的户名一致"
        :rules="[{ required: true, message: '请填写姓名（企业）' }]"
      />
      <van-field
        v-model="form.id_number"
        :disabled="disabled"
        name="id_number"
        label="身份证号（统一社会信用代码）"
        placeholder="身份证号（统一社会信用代码）"
        :rules="[{ required: true, message: '请填写证件号' }]"
      />
      <van-field
        v-model="form.telephone"
        :disabled="disabled"
        name="telephone"
        label="手机号"
        type="digit"
        placeholder="手机号"
        :rules="[{ required: true, message: '请填写手机号' }]"
      />
      <van-field
        v-model="form.car_price"
        :disabled="disabled"
        name="car_price"
        label="购车价格（含税）/元"
        type="number"
        placeholder="需与发票上购车金额一致"
        :rules="[{ required: true, message: '购车价不低于50000', validator: priceValidate }]"
      />
      <van-field
        readonly
        :disabled="disabled"
        clickable
        name="buy_date"
        :value="form.buy_date"
        label="购车日期"
        placeholder="购车日期和开票时间一致"
        @click="showPicker = true"
      />
      <van-popup v-model="showPicker" position="bottom">
        <van-datetime-picker
          v-model="currentDate"
          type="month-day"
          title="选择购车日期"
          :min-date="minDate"
          :max-date="maxDate"
          :formatter="formatter"
          @confirm="onConfirm"
          @cancel="showPicker = false"
        />
      </van-popup>
      <van-field
        v-model="form.bank_name"
        :disabled="disabled"
        name="bank_name"
        label="补贴收款银行开户行"
        placeholder="补贴收款银行开户行"
        :rules="[{ required: true, message: '请填写补贴收款银行开户行' }]"
      />
      <van-field
        v-model="form.bank_card_no"
        name="bank_card_no"
        :disabled="disabled"
        label="补贴收款银行账户号"
        placeholder="补贴收款银行账户号"
        :rules="[{ required: true, message: '请填写补贴收款银行账户号' }]"
      />
      <van-field name="photo_id_front" label="身份证（统一社会信用代码）照片（正面）" :disabled="disabled" :rules="[{ required: true, message: '请填上传图片' }]">
        <template #input>
          <van-uploader class="image-list" :deletable="form_id < 1" :max-size="10 * 1024 *1024" v-model="form.photo_id_front" :before-read="beforeReadImage" :after-read="afterReadImage" accept="image/*" @oversize="onOversize(10)" :max-count="1" ></van-uploader>
        </template>
      </van-field>
      <van-field name="photo_id_reverse" label="身份证照片（背面）" :disabled="disabled" >
        <template #input>
          <van-uploader class="image-list" :deletable="form_id < 1" :max-size="10 * 1024 *1024" v-model="form.photo_id_reverse" :before-read="beforeReadImage" :after-read="afterReadImage" accept="image/*" @oversize="onOversize(10)" :max-count="1" ></van-uploader>
        </template>
      </van-field>
      <van-field name="photo_invoice" label="购车发票照片" :disabled="disabled" :rules="[{ required: true, message: '请填上传图片' }]">
        <template #input>
          <van-uploader class="image-list" :deletable="form_id < 1" :max-size="10 * 1024 *1024" v-model="form.photo_invoice" :before-read="beforeReadImage" :after-read="afterReadImage" accept="image/*" @oversize="onOversize(10)" :max-count="1" ></van-uploader>
        </template>
      </van-field>
      <div v-if="$store.state.fid > 1">
        <van-field name="old_for_new" :disabled="disabled" label="以旧换新">
          <template #input>
            <van-switch :active-value="1" :disabled="disabled" :inactive-value="0" v-model="form.old_for_new" size="20" />
            <span style="font-size: 0.7rem;text-indent: 0.5em;"> 是否“以旧换新”方式购买新车</span>
          </template>
      </van-field>
      <van-field v-if="form.old_for_new == 1" name="photo_old_for_new" label="以旧换新相关凭证" :disabled="disabled" :rules="[{ required: true, message: '请填上传相关照片' }]">
        <template #input>
          <van-uploader class="image-list" :deletable="form_id < 1" :max-size="10 * 1024 *1024" v-model="form.photo_old_for_new" :before-read="beforeReadImage" :after-read="afterReadImage" accept="image/*" @oversize="onOversize(10)" multiple :max-count="5" ></van-uploader>
        </template>
        
      </van-field>
      
      <van-field v-if="form.old_for_new == 1"  name="photo_commitment" label="以旧换新承诺书" :disabled="disabled" :rules="[{ required: true, message: '请填上传相关照片' }]">
        <template #input>
          <van-uploader class="image-list" :deletable="form_id < 1" :max-size="10 * 1024 *1024" v-model="form.photo_commitment" :before-read="beforeReadImage" :after-read="afterReadImage" accept="image/*" @oversize="onOversize(10)" :max-count="1" ></van-uploader>
        </template>
      </van-field>
      </div>
      <div style="margin: 16px;padding-bottom: 2rem;" v-if="form_id == 0">
        <van-button round :disabled="disabled" block type="info" native-type="submit">提交</van-button>
      </div>
    </van-form>
    <van-form v-if="form_id > 0" @submit="onSubmit2">
        <van-field name="photo_driving_license" label="车辆行驶证照片" :disabled="disabled2" :rules="[{ required: true, message: '请填上传图片' }]">
          <template #input>
            <van-uploader class="image-list" :max-size="10 * 1024 *1024" v-model="form.photo_driving_license" :before-read="beforeReadImage" :after-read="afterReadImage" accept="image/*" @oversize="onOversize(10)" :max-count="1" ></van-uploader>
          </template>
        </van-field>
        <van-field name="photo_purchase_tax" label="车辆购置税凭证照片" :disabled="disabled2" :rules="[{ required: true, message: '请填上传图片' }]">
          <template #input>
            <van-uploader class="image-list"  :max-size="10 * 1024 *1024" v-model="form.photo_purchase_tax" :before-read="beforeReadImage" :after-read="afterReadImage" accept="image/*" @oversize="onOversize(10)" :max-count="1" ></van-uploader>
          </template>
        </van-field>
        <div style="margin: 16px;padding-bottom: 2rem;" v-if="form_id > 0">
          <van-button round :disabled="disabled2" block type="info" native-type="submit">提交</van-button>
        </div>
      </van-form>
  </div>
</template>
<script>

import axios from 'axios'
import Compressor from 'compressorjs'
import { mc,util } from '../../assets/common2.js'
import { ImagePreview } from 'vant'
// import Vconsole from 'vconsole/dist/vconsole.min.js'
// let vConsole = new Vconsole()
export default {
  name: 'CarForm',
  props: {
  },
  data () {
    return {
      photo_id_front: [],
      form:{
        name:'',
        telephone: '',
        type: '',
        id_number: '',
        car_price: null,
        buy_date: null,
        bank_name: '',
        bank_card_no: '',
        photo_id_front: [],
        photo_id_reverse: [],
        photo_invoice: [],
        photo_driving_license: [],
        photo_purchase_tax: [],
        photo_old_for_new: [],
        photo_commitment: [],
        old_for_new: 0,
      },
      disabled: false,
      disabled2: false,
      currentDate: new Date(),
      // minDate: new Date(2024, 1, 1),
      // maxDate: new Date(2024, 2, 20),
      showPicker: false,
      uploading: {
        photo_id_front: false,
        photo_id_reverse: false,
        photo_invoice: false,
        photo_purchase_tax: false,
        photo_driving_license: false,
        photo_old_for_new: false,
        photo_commitment: false,
      },
      photo_old_for_new: []
    }
  },
  components: {
    [ImagePreview.Component.name]: ImagePreview.Component,
  },
  computed: {
    minDate () {
      return this.$store.state.fid == 1 ? new Date(2024, 1, 1) : new Date(2024, 3, 30)
    },
    maxDate () {
      return this.$store.state.fid == 1 ? new Date(2024, 2, 20) : new Date(2024, 4, 3)
    }
  },
  created: function () {
    this.form_id = this.$route.params.form_id
    if (this.$route.params.form_id > 0) {
      this.disabled = true
      this.getDetail()
    }
    // this.active = this.$store.state.prevActive
  },
  mounted: function () {
    // console.log(vConsole);
  },
  methods: {
    onConfirm(date) {
      this.form.buy_date = date.toLocaleString().split(' ')[0]
      this.showPicker = false
    },
    priceValidate (val) {
      return val >= 50000
    },
    formatter(type, val) {
      if (type === 'month') {
        return `${val}月`;
      } else if (type === 'day') {
        return `${val}日`;
      }
      return val;
    },
    upload (key) {
      this.uploading[key] = true
      let n = key == 'photo_old_for_new' ? 5 : 1
      mc.photoSelect(n,(data) => {
        if (data.status == 'complete') {
          let imgs = this.form[key] == '' ? [] : this.form[key].split(',')
          this.form[key] = imgs.concat(data.imgs.map(e => {
            return e.url.replace('http:','')
          })).join(',')
          // console.log(data.imgs);
          this.uploading[key] = false
        } else {
          this.uploading[key] = false
        }
      })
    },
    beforeReadImage (file) {
      var result = []
      if (file instanceof Array) {
        for (var f of file) {
          if (!/image.*/.test(f.type)) {
            this.$toast.fail('请上传图片');
            return false;
          }
          result.push(new Promise((resolve) => {
            new Compressor(f, {
              quality: 0.2,
              success: resolve,
              error(err) {
                console.log(err.message);
              },
            })
          }))
        }
      } else {
        result = new Promise((resolve) => {
          new Compressor(file, {
            quality: 0.7,
            success: resolve,
            error(err) {
              console.log(err.message);
            },
          })
        })
      }
      return result
    },
    afterReadImage (file) {
      if (file instanceof Array) {
        for (var f of file) {
          this.uploadHandle(f, 'img')
        }
      } else {
        this.uploadHandle(file, 'img')
      }
    },
    uploadHandle(file) {
      file.status = 'uploading'
      file.message = '上传中...'
      var data = new FormData()
      data.append('id', 'r5')
      data.append('file', file.file)
      data.append('session', this.session)
      util.Arequest((data2) => {
        data.append('token',data2.token)
        axios.post(`/encrypt3/form/upload/img?userid=${data2.userid}&fid=${this.$store.state.fid}`,data).then(res => {
            if (res.data.msg == 'ok') {
              file.url = res.data.url
              file.status = 'done'
              file.message = ''
            } else {
              file.status = 'failed'
              file.message = '上传失败'
            } 
          }).catch(() => {
            file.status = 'failed'
            file.message = '上传失败'
          })
      })
    },

    preview(img) {
      ImagePreview([img])
    },
    onSubmit(values) {
      values.type = parseInt(values.type)
      values.buy_date = this.currentDate
      values.photo_id_front = values.photo_id_front[0]['url']
      values.photo_id_reverse = values.photo_id_reverse[0]['url']
      values.photo_invoice = values.photo_invoice[0]['url']
      values.photo_old_for_new && (values.photo_old_for_new = values.photo_old_for_new.map(e => e.url).join(','))
      values.photo_commitment && (values.photo_commitment = values.photo_commitment[0]['url'])
      // console.log(values);
      util.Arequest((data) => {
        values.token = data.token
        axios.post(`/encrypt3/form/car/submit1?userid=${data.userid}&fid=${this.$store.state.fid}`,values).then(res => {
            if (res.data.msg == 'ok') {
              this.disabled = true
              this.$store.commit('setNeedRefresh',true)
              this.$toast('提交成功')
            } else if (res.data.msg == 'not admin') {
              this.disabled = true
              this.$toast('无权限')
            } else if (res.data.msg == 'exists') {
              // this.disabled = true
              this.$toast('车主已经存在\n无法再次提交')
            } else if (res.data.msg == 'no start') {
              // this.disabled = true
              this.$toast('申请还未开始')
            } else if (res.data.msg == 'end') {
              // this.disabled = true
              this.$toast('申请已经结束')
            } else {
              this.$toast('提交失败\n请重试')
            } 
          }).catch(() => {
            
            this.$toast('网络繁忙\n稍后请重试')
          })
      })
    },
    onSubmit2(values) {
      util.Arequest((data) => {
        var data2 = {
          form_id: this.form_id,
          photo_driving_license: values.photo_driving_license[0]['url'],
          photo_purchase_tax: values.photo_purchase_tax[0]['url'],
          token: data.token
        }
        axios.post(`/encrypt3/form/car/submit2?userid=${data.userid}&fid=${this.$store.state.fid}`,data2).then(res => {
            if (res.data.msg == 'ok') {
              this.disabled2 = true
              this.$store.commit('setNeedRefresh',true)
              this.$toast('提交成功')
            } else if (res.data.msg == 'not admin') {
              this.disabled = true
              this.$toast('无权限')
            } else if (res.data.msg == 'error form_id') {
              this.disabled = true
              this.$store.commit('setNeedRefresh',true)
              this.$toast('该申请不存在')
            } else if (res.data.msg == 'error merchant') {
              this.disabled = true
              this.$toast('申请不属于该经销商')
            } else if (res.data.msg == 'error status') {
              this.disabled = true
              this.$store.commit('setNeedRefresh',true)
              this.$toast('该申请已提交或已作废')
            } else if (res.data.msg == 'no start') {
              this.disabled = true
              this.$toast('申请还未开始')
            } else if (res.data.msg == 'end') {
              this.disabled = true
              this.$toast('申请已经结束')
            } else {
              this.$toast('提交失败\n请重试')
            } 
          }).catch(() => {
            this.$toast('网络繁忙\n请重试')
          })
      })
    },
    getDetail() {
      util.Arequest((data) => {
        axios.post(`/encrypt3/form/detail?form_id=${this.form_id}&userid=${data.userid}&fid=${this.$store.state.fid}`,{token:data.token}).then(res => {
            if (res.data.msg == 'ok') {
              res.data.form.type = ''+res.data.form.type
              // this.form = res.data.form
              let form = res.data.form
              this.form = {
                name: form.name,
                telephone: form.telephone,
                type: form.type,
                id_number: form.id_number,
                car_price: form.car_price,
                buy_date: form.buy_date,
                bank_name: form.bank_name,
                bank_card_no: form.bank_card_no,
                photo_id_front: form.photo_id_front.split(',').map(e => {
                  return {url:e}
                }),
                photo_id_reverse: form.photo_id_reverse.split(',').map(e => {
                  return {url:e}
                }),
                photo_invoice: form.photo_invoice.split(',').map(e => {
                  return {url:e}
                }),
                photo_driving_license: form.photo_driving_license ? form.photo_driving_license.split(',').map(e => {
                  return {url:e}
                }) : [],
                photo_purchase_tax: form.photo_purchase_tax ? form.photo_purchase_tax.split(',').map(e => {
                  return {url:e}
                }) : [],
                photo_old_for_new: form.photo_old_for_new ? form.photo_old_for_new.split(',').map(e => {
                  return {url:e}
                }) : [],
                photo_commitment: form.photo_commitment ? form.photo_commitment.split(',').map(e => {
                  return {url:e}
                }) : [],
                old_for_new: form.old_for_new,
              }
              this.loading = false;
            } else if (res.data.msg == 'not admin') {
              this.$toast('无权限')
            } else if (res.data.msg == 'not exists') {
              this.$toast('没有该申请')
            } else if (res.data.msg == 'error merchant') {
              this.$toast('非法请求')
            } else {
              this.$toast('网络繁忙\n稍后重试')
            } 
          }).catch(() => {
            this.$toast('网络繁忙\n稍后重试')
          })
      })
    },
    
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* .main {
  margin-top: 56.3vw;
} */
.tips {
  font-size: 1rem;
  color: red;
  padding: 0 1rem;
  text-align: left;
  line-height: 2rem;
}
.upload-bar {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  width: 100%;
  height: 4.5rem;
}
.upload-icon {
  position: relative;
  width: 4.5rem;
  height: 4.5rem;
}
.upload-delete {
  position: absolute;
    top: 0;
    right: 0;
    width: 14px;
    height: 14px;
    background-color: rgba(0, 0, 0, 0.7);
    border-radius: 0 0 0 12px;
}
.upload-tips {
  margin-left: 2rem;
  width: 6rem;
  font-size: 0.8rem;
  color: rgb(255, 76, 76);
}
.upload-list {
  display: flex;
  flex-wrap: wrap;
}
.upload-list .upload-item {
  margin-right: 0.2rem;
  margin-top: 0.2rem;
}
</style>
